(function () {
    const SCORES = {
        'A':1,'B':3,'C':3,'D':2,'E':1,'F':4,'G':2,'H':4,'I':1,'J':8,'K':5,'L':1,'M':3,
        'N':1,'O':1,'P':3,'Q':10,'R':1,'S':1,'T':1,'U':1,'V':4,'W':4,'X':8,'Y':4,'Z':10
    };

    // Preview colors (on-screen)
    const PREVIEW_BASE   = '#d4c3a7';
    const PREVIEW_DETAIL = '#8c7651';

    // Laser colors (downloaded SVG)
    const LASER_CUT     = '#ff0000';
    const LASER_SCORE   = '#0000ff';
    const LASER_ENGRAVE = '#000000';

    const IN_TO_MM = 25.4;

    let grid = new Map();
    let currentViewBox = { w: 400, h: 200 };
    let exportFont = null;

    // Export size state
    let exportWidth = 4;
    let exportUnit  = 'in';   // 'in' or 'mm'

    const wordInput   = document.getElementById('wordInput');
    const shuffleBtn  = document.getElementById('shuffleBtn');
    const saveBtn     = document.getElementById('saveSvgBtn');
    const svgEl       = document.getElementById('scrabbleSvg');
    const sizeValue   = document.getElementById('sizeValue');
    const sizeDown    = document.getElementById('sizeDown');
    const sizeUp      = document.getElementById('sizeUp');
    const unitInBtn   = document.getElementById('unitIn');
    const unitMmBtn   = document.getElementById('unitMm');
    const exportInfo  = document.getElementById('exportInfo');

    /* ── helpers ───────────────────────────────────────────── */

    function debounce(fn, ms) {
        let timer;
        return (...args) => { clearTimeout(timer); timer = setTimeout(() => fn(...args), ms); };
    }

    function addChar(parent, ch, cx, cy, size, fill) {
        const t = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        t.setAttribute('x', cx);
        t.setAttribute('y', cy + size * 0.38);
        t.setAttribute('text-anchor', 'middle');
        t.setAttribute('font-size', size);
        t.setAttribute('font-family', 'Arial, Helvetica, sans-serif');
        t.setAttribute('font-weight', 'bold');
        t.setAttribute('fill', fill);
        t.textContent = ch;
        parent.appendChild(t);
    }

    function addNumber(parent, num, cx, cy, size, fill) {
        const t = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        t.setAttribute('x', cx);
        t.setAttribute('y', cy + size * 0.38);
        t.setAttribute('text-anchor', 'middle');
        t.setAttribute('font-size', size);
        t.setAttribute('font-family', 'Arial, Helvetica, sans-serif');
        t.setAttribute('font-weight', 'bold');
        t.setAttribute('fill', fill);
        t.textContent = num.toString();
        parent.appendChild(t);
    }

    function ensureDemoTile() {
        if (grid.size === 0) grid.set('0,0', { letter:'?', dirs: new Set(['h']) });
    }

    function mkEl(tag, attrs) {
        const e = document.createElementNS('http://www.w3.org/2000/svg', tag);
        for (const [k,v] of Object.entries(attrs)) e.setAttribute(k, String(v));
        return e;
    }

    /* ── boolean-union rasteriser ──────────────────────────── */
    const SCALE = 8;

    function paintCircle(pixels, cols, cx, cy, r) {
        const x0 = Math.floor(cx - r), x1 = Math.ceil(cx + r);
        const y0 = Math.floor(cy - r), y1 = Math.ceil(cy + r);
        for (let py = y0; py <= y1; py++) {
            for (let px = x0; px <= x1; px++) {
                if (px < 0 || py < 0 || px >= cols) continue;
                const dx = px - cx, dy = py - cy;
                if (dx*dx + dy*dy <= r*r) {
                    const idx = py * cols + px;
                    if (idx >= 0 && idx < pixels.length) pixels[idx] = 1;
                }
            }
        }
    }

    function paintRoundedRect(pixels, cols, x, y, w, h, r) {
        r = Math.min(r, w/2, h/2);
        const x0=Math.floor(x), x1=Math.ceil(x+w);
        const y0=Math.floor(y), y1=Math.ceil(y+h);
        for (let py = y0; py < y1; py++) {
            for (let px = x0; px < x1; px++) {
                if (px < 0 || py < 0 || px >= cols) continue;
                const nx = Math.max(x+r, Math.min(x+w-r, px+0.5));
                const ny = Math.max(y+r, Math.min(y+h-r, py+0.5));
                const dx = (px+0.5) - nx;
                const dy = (py+0.5) - ny;
                if (dx*dx + dy*dy <= r*r || (px+0.5 >= x+r && px+0.5 <= x+w-r) || (py+0.5 >= y+r && py+0.5 <= y+h-r)) {
                    const idx = py * cols + px;
                    if (idx >= 0 && idx < pixels.length) pixels[idx] = 1;
                }
            }
        }
    }

    function eraseCircle(pixels, cols, cx, cy, r) {
        const x0 = Math.floor(cx - r), x1 = Math.ceil(cx + r);
        const y0 = Math.floor(cy - r), y1 = Math.ceil(cy + r);
        for (let py = y0; py <= y1; py++) {
            for (let px = x0; px <= x1; px++) {
                if (px < 0 || py < 0 || px >= cols) continue;
                const dx = px - cx, dy = py - cy;
                if (dx*dx + dy*dy <= r*r) {
                    const idx = py * cols + px;
                    if (idx >= 0 && idx < pixels.length) pixels[idx] = 0;
                }
            }
        }
    }

    function extractContours(pixels, cols, rows, svgScale) {
        const edgeMap = new Map();
        function addEdge(ax,ay,bx,by) {
            const k = `${ax},${ay}`;
            if (!edgeMap.has(k)) edgeMap.set(k, []);
            edgeMap.get(k).push([bx,by]);
        }
        function px(col,row) { return pixels[row*cols+col] === 1; }
        for (let row = 0; row < rows; row++) {
            for (let col = 0; col < cols; col++) {
                if (!px(col,row)) continue;
                if (row === 0 || !px(col, row-1)) addEdge(col, row,   col+1, row);
                if (row === rows-1 || !px(col, row+1)) addEdge(col+1, row+1, col,   row+1);
                if (col === 0 || !px(col-1, row)) addEdge(col, row+1, col,   row);
                if (col === cols-1 || !px(col+1, row)) addEdge(col+1, row,   col+1, row+1);
            }
        }
        const rings = [];
        const usedKeys = new Set();
        for (const startKey of edgeMap.keys()) {
            if (usedKeys.has(startKey)) continue;
            const [sx,sy] = startKey.split(',').map(Number);
            const ring = [[sx,sy]];
            let curKey = startKey;
            let safe = 0;
            while (safe++ < 100000) {
                const nexts = edgeMap.get(curKey);
                if (!nexts || nexts.length === 0) break;
                const [nx,ny] = nexts.pop();
                if (nexts.length === 0) edgeMap.delete(curKey);
                usedKeys.add(curKey);
                const nk = `${nx},${ny}`;
                if (nx === sx && ny === sy) break;
                ring.push([nx,ny]);
                curKey = nk;
            }
            if (ring.length >= 3) {
                const svgRing = ring.map(([x,y]) => [x / svgScale, y / svgScale]);
                rings.push(svgRing);
            }
        }
        return rings;
    }

    function ringsToPath(rings) {
        let d = '';
        for (const ring of rings) {
            const reduced = reducePoints(simplifyCollinear(ring), 0.3);
            if (reduced.length < 3) continue;
            d += `M ${reduced[0][0].toFixed(2)},${reduced[0][1].toFixed(2)} `;
            for (let i = 1; i < reduced.length; i++) {
                d += `L ${reduced[i][0].toFixed(2)},${reduced[i][1].toFixed(2)} `;
            }
            d += 'Z ';
        }
        return d;
    }

    /* Ramer-Douglas-Peucker: removes points closer than `tol`
       to the line between their neighbours, smoothing staircase
       edges while preserving the overall shape. */
    function reducePoints(pts, tol) {
        if (pts.length <= 4) return pts;

        function rdp(points, start, end, tol, keep) {
            let maxDist = 0, maxIdx = start;
            const [sx, sy] = points[start];
            const [ex, ey] = points[end];
            const dx = ex - sx, dy = ey - sy;
            const lenSq = dx*dx + dy*dy;

            for (let i = start + 1; i < end; i++) {
                let dist;
                if (lenSq === 0) {
                    const px = points[i][0] - sx, py = points[i][1] - sy;
                    dist = Math.sqrt(px*px + py*py);
                } else {
                    const t = Math.max(0, Math.min(1, ((points[i][0]-sx)*dx + (points[i][1]-sy)*dy) / lenSq));
                    const px = points[i][0] - (sx + t*dx);
                    const py = points[i][1] - (sy + t*dy);
                    dist = Math.sqrt(px*px + py*py);
                }
                if (dist > maxDist) { maxDist = dist; maxIdx = i; }
            }
            if (maxDist > tol) {
                rdp(points, start, maxIdx, tol, keep);
                keep.add(maxIdx);
                rdp(points, maxIdx, end, tol, keep);
            }
        }

        const keep = new Set([0, pts.length - 1]);
        rdp(pts, 0, pts.length - 1, tol, keep);
        return pts.filter((_, i) => keep.has(i));
    }

    function simplifyCollinear(pts) {
        if (pts.length <= 3) return pts;
        const out = [pts[0]];
        for (let i = 1; i < pts.length - 1; i++) {
            const [ax,ay] = pts[i-1];
            const [bx,by] = pts[i];
            const [cx,cy] = pts[i+1];
            const cross = (bx-ax)*(cy-ay) - (by-ay)*(cx-ax);
            if (Math.abs(cross) > 0.001) out.push(pts[i]);
        }
        out.push(pts[pts.length-1]);
        return out;
    }

    /* ── compute layout geometry (shared by preview + export) ── */

    function computeLayout(g) {
        let minX=Infinity, minY=Infinity, maxX=-Infinity, maxY=-Infinity;
        for (const key of g.keys()) {
            const [x,y] = key.split(',').map(Number);
            if (x<minX) minX=x; if (y<minY) minY=y;
            if (x>maxX) maxX=x; if (y>maxY) maxY=y;
        }

        const T   = 50;
        const PAD = 20;
        const OR  = 16;
        const IR  = 8;
        const OVR = 6;
        const TOP_PAD = PAD + OR*2 - OVR;
        const INSET = 4;
        const W = (maxX-minX+1)*T + PAD*2;
        const H = (maxY-minY+1)*T + TOP_PAD + PAD;

        const offX = PAD - minX*T;
        const offY = TOP_PAD - minY*T;

        const sorted = Array.from(g.keys()).sort((a,b) => {
            const [ax,ay]=a.split(',').map(Number), [bx,by]=b.split(',').map(Number);
            return ay-by||ax-bx;
        });

        const topRowTiles = sorted.filter(k => parseInt(k.split(',')[1]) === minY);
        const topRowXs = topRowTiles.map(k => parseInt(k.split(',')[0]));
        const topRowMinX = Math.min(...topRowXs);
        const topRowMaxX = Math.max(...topRowXs);
        const ringCX = offX + (topRowMinX + topRowMaxX + 1) * T / 2;

        let nearestTileTopY = Infinity;
        let closestFallbackY = Infinity;
        let closestFallbackDist = Infinity;

        for (const key of sorted) {
            const [gx, gy] = key.split(',').map(Number);
            const tileLeft    = offX + gx * T;
            const tileRight   = tileLeft + T;
            const tileTop     = offY + gy * T;
            const tileCenterX = tileLeft + T / 2;
            if (ringCX >= tileLeft && ringCX <= tileRight) {
                if (tileTop < nearestTileTopY) nearestTileTopY = tileTop;
            }
            const dist = Math.abs(tileCenterX - ringCX);
            if (dist < closestFallbackDist || (dist === closestFallbackDist && tileTop < closestFallbackY)) {
                closestFallbackDist = dist;
                closestFallbackY = tileTop;
            }
        }

        const attachY = isFinite(nearestTileTopY) ? nearestTileTopY : closestFallbackY;
        const ringCY = attachY - OR + OVR;

        /* boolean-union path data */
        const rCols = Math.ceil(W * SCALE) + 2;
        const rRows = Math.ceil(H * SCALE) + 2;
        const pixels = new Uint8Array(rCols * rRows);

        for (const key of sorted) {
            const [x,y] = key.split(',').map(Number);
            paintRoundedRect(pixels, rCols,
                (offX + x*T) * SCALE,
                (offY + y*T) * SCALE,
                T * SCALE, T * SCALE, 6 * SCALE
            );
        }
        paintCircle(pixels, rCols, ringCX*SCALE, ringCY*SCALE, OR*SCALE);
        eraseCircle(pixels, rCols, ringCX*SCALE, ringCY*SCALE, IR*SCALE);

        const rings = extractContours(pixels, rCols, rRows, SCALE);
        const pathData = ringsToPath(rings);

        return { W, H, T, PAD, INSET, OR, IR, offX, offY, ringCX, ringCY, sorted, pathData, minX, minY };
    }

    /* ── render preview ───────────────────────────────────── */

    function renderBoard() {
        while (svgEl.firstChild) svgEl.removeChild(svgEl.firstChild);
        ensureDemoTile();

        const lay = computeLayout(grid);
        const { W, H, T, INSET, offX, offY, sorted, pathData } = lay;

        currentViewBox = { w: W, h: H };
        svgEl.setAttribute('viewBox', `0 0 ${W} ${H}`);
        svgEl.removeAttribute('width');
        svgEl.removeAttribute('height');

        /* base shape — filled preview color */
        const baseGroup = mkEl('g', { id:'layer-cut' });
        baseGroup.appendChild(mkEl('path', {
            d: pathData,
            fill: PREVIEW_BASE,
            stroke: 'none',
            'fill-rule': 'evenodd'
        }));
        svgEl.appendChild(baseGroup);

        /* inner tile borders — score layer */
        const showInner = document.getElementById('showInnerBorder');
        const drawInnerBorder = showInner ? showInner.checked : true;

        const outlineGroup = mkEl('g', { id:'layer-score', fill:'none', stroke: PREVIEW_DETAIL, 'stroke-width':'1' });
        for (const key of sorted) {
            const [x,y] = key.split(',').map(Number);
            if (drawInnerBorder) {
                outlineGroup.appendChild(mkEl('rect', {
                    x: offX+x*T+INSET, y: offY+y*T+INSET,
                    width: T-INSET*2, height: T-INSET*2,
                    rx: 3, ry: 3
                }));
            }
        }

        /* dividers between adjacent tiles */
        const divGroup = mkEl('g', { id:'layer-dividers', fill:'none', stroke: PREVIEW_DETAIL, 'stroke-width':'1' });
        for (const key of sorted) {
            const [x,y] = key.split(',').map(Number);
            if (grid.has((x+1)+','+y)) {
                const lx = offX + (x+1)*T;
                divGroup.appendChild(mkEl('line', {
                    x1: lx, y1: offY+y*T+INSET,
                    x2: lx, y2: offY+y*T+T-INSET
                }));
            }
            if (grid.has(x+','+(y+1))) {
                const ly = offY + (y+1)*T;
                divGroup.appendChild(mkEl('line', {
                    x1: offX+x*T+INSET, y1: ly,
                    x2: offX+x*T+T-INSET, y2: ly
                }));
            }
        }
        svgEl.appendChild(outlineGroup);
        svgEl.appendChild(divGroup);

        /* engrave — letters + scores */
        const engraveGroup = mkEl('g', { id:'layer-engrave', fill: PREVIEW_DETAIL });
        for (const key of sorted) {
            const [x,y] = key.split(',').map(Number);
            const cell   = grid.get(key);
            const letter = cell.letter;
            const score  = SCORES[letter] !== undefined ? SCORES[letter] : 0;
            const rx = offX+x*T, ry = offY+y*T;
            addChar(engraveGroup, letter, rx+T/2, ry+T/2-2, 30, PREVIEW_DETAIL);
            addNumber(engraveGroup, score, rx+T-10, ry+T-10, 9, PREVIEW_DETAIL);
        }
        svgEl.appendChild(engraveGroup);

        updateExportInfo();
    }

    /* ── placement logic ──────────────────────────────────── */

    function canPlace(word, sx, sy, dx, dy, g) {
        const dir = dx===1?'h':'v';
        for (let i=0; i<word.length; i++) {
            const x=sx+i*dx, y=sy+i*dy, key=`${x},${y}`;
            const ex = g.get(key);
            if (ex && ex.letter!==word[i]) return false;
            if (!ex) {
                if (dir==='h' && (g.has(`${x},${y-1}`) || g.has(`${x},${y+1}`))) return false;
                if (dir==='v' && (g.has(`${x-1},${y}`) || g.has(`${x+1},${y}`))) return false;
            }
            if (i===0 && g.has(`${sx-dx},${sy-dy}`)) return false;
            if (i===word.length-1 && g.has(`${x+dx},${y+dy}`)) return false;
        }
        return true;
    }

    function placeWord(word, sx, sy, dx, dy, g) {
        const dir = dx===1?'h':'v';
        for (let i=0; i<word.length; i++) {
            const x=sx+i*dx, y=sy+i*dy, key=`${x},${y}`;
            const ex = g.get(key);
            if (ex) ex.dirs.add(dir);
            else g.set(key, { letter:word[i], dirs: new Set([dir]) });
        }
    }

    function countCrossings(word, sx, sy, dx, dy, g) {
        let n = 0;
        for (let i = 0; i < word.length; i++) {
            if (g.has(`${sx + i*dx},${sy + i*dy}`)) n++;
        }
        return n;
    }

    function gridBounds(g) {
        let minX=Infinity, minY=Infinity, maxX=-Infinity, maxY=-Infinity;
        for (const key of g.keys()) {
            const [x,y] = key.split(',').map(Number);
            if (x<minX) minX=x; if (y<minY) minY=y;
            if (x>maxX) maxX=x; if (y>maxY) maxY=y;
        }
        return { minX, minY, maxX, maxY, w: maxX-minX+1, h: maxY-minY+1 };
    }

    /* Build grid from an ordered word list. */
    function buildGridFromOrder(words) {
        if (!words.length) return { grid: new Map(), placedCount: 0 };

        const g = new Map();
        if (words.length === 1) {
            placeWord(words[0], 0, 0, 0, 1, g);
            return { grid: g, placedCount: 1 };
        }

        placeWord(words[0], 0, 0, 1, 0, g);
        const placed  = new Set([0]);
        const unplaced = new Set(words.map((_,i) => i).slice(1));

        let progress = true;
        while (progress && unplaced.size > 0) {
            progress = false;
            for (const idx of [...unplaced]) {
                const word = words[idx];
                const candidates = [];
                for (const [key, cell] of g.entries()) {
                    const [x, y] = key.split(',').map(Number);
                    for (let i = 0; i < word.length; i++) {
                        if (word[i] !== cell.letter) continue;
                        if (canPlace(word, x, y-i, 0, 1, g)) {
                            candidates.push({ sx: x, sy: y-i, dx: 0, dy: 1,
                                crossings: countCrossings(word, x, y-i, 0, 1, g) });
                        }
                        if (canPlace(word, x-i, y, 1, 0, g)) {
                            candidates.push({ sx: x-i, sy: y, dx: 1, dy: 0,
                                crossings: countCrossings(word, x-i, y, 1, 0, g) });
                        }
                    }
                }
                if (candidates.length > 0) {
                    candidates.sort((a, b) => b.crossings - a.crossings);
                    const best = candidates[0];
                    placeWord(word, best.sx, best.sy, best.dx, best.dy, g);
                    placed.add(idx);
                    unplaced.delete(idx);
                    progress = true;
                }
            }
        }
        return { grid: g, placedCount: placed.size };
    }

    /* Fisher-Yates shuffle (in place) */
    function shuffleArray(arr) {
        for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        return arr;
    }

    /* Try many random orderings, keep best result. */
    function buildGrid(lines, forceNewShuffle) {
        let words = lines.map(w => w.trim().toUpperCase().replace(/[^A-Z]/g, '')).filter(w => w.length > 0);
        if (!words.length) return new Map();

        const ATTEMPTS = 60;
        let bestGrid = null;
        let bestPlaced = 0;
        let bestArea = Infinity;

        for (let a = 0; a < ATTEMPTS; a++) {
            let order;
            if (a === 0 && !forceNewShuffle) {
                order = [...words].sort((x,y) => y.length - x.length);
            } else {
                order = shuffleArray([...words]);
            }
            const { grid: g, placedCount } = buildGridFromOrder(order);
            if (placedCount > bestPlaced) {
                bestPlaced = placedCount;
                const b = gridBounds(g);
                bestArea = b.w * b.h;
                bestGrid = g;
            } else if (placedCount === bestPlaced) {
                const b = gridBounds(g);
                const area = b.w * b.h;
                if (area < bestArea) {
                    bestArea = area;
                    bestGrid = g;
                }
            }
            if (bestPlaced === words.length && a >= 10) break;
        }

        return bestGrid || new Map();
    }

    /* ── export size controls ─────────────────────────────── */

    function getStep() { return exportUnit === 'in' ? 0.25 : 5; }
    function getMin()  { return exportUnit === 'in' ? 1 : 25; }
    function getMax()  { return exportUnit === 'in' ? 24 : 610; }

    function clampSize(v) {
        return Math.max(getMin(), Math.min(getMax(), v));
    }

    function syncSizeInput() {
        const decimals = exportUnit === 'in' ? 2 : 0;
        sizeValue.value = parseFloat(exportWidth.toFixed(decimals));
    }

    function setUnit(unit) {
        if (unit === exportUnit) return;
        // Convert value — update exportUnit first so clampSize uses correct bounds
        let converted;
        if (unit === 'mm') {
            // Round to nearest 5 mm
            converted = Math.round((exportWidth * IN_TO_MM) / 5) * 5;
        } else {
            // Round to nearest 0.25 in
            converted = Math.round((exportWidth / IN_TO_MM) / 0.25) * 0.25;
        }
        exportUnit = unit;
        exportWidth = clampSize(converted);
        unitInBtn.classList.toggle('active', unit === 'in');
        unitMmBtn.classList.toggle('active', unit === 'mm');
        syncSizeInput();
        updateExportInfo();
    }

    function updateExportInfo() {
        const { w: vbW, h: vbH } = currentViewBox;
        if (!vbW || !vbH) return;
        const aspect = vbW / vbH;

        let wIn, hIn;
        if (exportUnit === 'mm') {
            wIn = exportWidth / IN_TO_MM;
        } else {
            wIn = exportWidth;
        }
        hIn = wIn / aspect;

        if (exportUnit === 'mm') {
            const wMm = exportWidth;
            const hMm = +(hIn * IN_TO_MM).toFixed(0);
            exportInfo.textContent = `Ornament \u2248 ${wMm} \u00d7 ${hMm} mm when cut`;
        } else {
            const wDisp = +wIn.toFixed(2);
            const hDisp = +hIn.toFixed(2);
            exportInfo.textContent = `Ornament \u2248 ${wDisp} \u00d7 ${hDisp} in when cut`;
        }
    }

    sizeDown.addEventListener('click', () => {
        exportWidth = clampSize(exportWidth - getStep());
        syncSizeInput();
        updateExportInfo();
    });
    sizeUp.addEventListener('click', () => {
        exportWidth = clampSize(exportWidth + getStep());
        syncSizeInput();
        updateExportInfo();
    });
    sizeValue.addEventListener('change', () => {
        exportWidth = clampSize(parseFloat(sizeValue.value) || getMin());
        syncSizeInput();
        updateExportInfo();
    });
    unitInBtn.addEventListener('click', () => setUnit('in'));
    unitMmBtn.addEventListener('click', () => setUnit('mm'));

    /* ── event wiring ─────────────────────────────────────── */

    const liveGenerate = debounce(() => {
        grid = buildGrid(wordInput.value.split('\n'), false);
        renderBoard();
    }, 250);

    wordInput.addEventListener('input', liveGenerate);

    document.getElementById('showInnerBorder').addEventListener('change', () => { renderBoard(); });

    shuffleBtn.addEventListener('click', () => {
        // Add spin class for animation
        const icon = shuffleBtn.querySelector('.shuffle-icon');
        if (icon) {
            icon.classList.remove('spin');
            void icon.offsetWidth; // reflow to restart animation
            icon.classList.add('spin');
        }
        grid = buildGrid(wordInput.value.split('\n'), true);
        renderBoard();
    });

    /* ── save SVG — laser colors, outlines, legend ─────────── */

    saveBtn.addEventListener('click', () => {
        if (!grid.size) { alert('Add some words first.'); return; }
        if (!exportFont) { alert('Font is still loading — please try again in a moment.'); return; }
        ensureDemoTile();

        const lay = computeLayout(grid);
        const { W, H, T, INSET, offX, offY, sorted, pathData } = lay;

        const LEGEND_H = 30;
        const totalH = H + LEGEND_H;

        const showInner = document.getElementById('showInnerBorder');
        const drawInnerBorder = showInner ? showInner.checked : true;

        /* build SVG string */
        let svg = '';
        svg += `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${W} ${totalH}">\n`;

        /* CUT layer — outline only */
        svg += `<g id="layer-cut">\n`;
        svg += `  <path d="${pathData}" fill="none" stroke="${LASER_CUT}" stroke-width="1" fill-rule="evenodd"/>\n`;
        svg += `</g>\n`;

        /* SCORE layer — inner borders + dividers — outline only */
        svg += `<g id="layer-score" fill="none" stroke="${LASER_SCORE}" stroke-width="1">\n`;
        for (const key of sorted) {
            const [x,y] = key.split(',').map(Number);
            if (drawInnerBorder) {
                svg += `  <rect x="${offX+x*T+INSET}" y="${offY+y*T+INSET}" width="${T-INSET*2}" height="${T-INSET*2}" rx="3" ry="3"/>\n`;
            }
        }
        for (const key of sorted) {
            const [x,y] = key.split(',').map(Number);
            if (grid.has((x+1)+','+y)) {
                const lx = offX + (x+1)*T;
                svg += `  <line x1="${lx}" y1="${offY+y*T+INSET}" x2="${lx}" y2="${offY+y*T+T-INSET}"/>\n`;
            }
            if (grid.has(x+','+(y+1))) {
                const ly = offY + (y+1)*T;
                svg += `  <line x1="${offX+x*T+INSET}" y1="${ly}" x2="${offX+x*T+T-INSET}" y2="${ly}"/>\n`;
            }
        }
        svg += `</g>\n`;

        /* ENGRAVE layer — outlined text paths */
        svg += `<g id="layer-engrave" fill="${LASER_ENGRAVE}">\n`;
        for (const key of sorted) {
            const [x,y] = key.split(',').map(Number);
            const cell   = grid.get(key);
            const letter = cell.letter;
            const score  = SCORES[letter] !== undefined ? SCORES[letter] : 0;
            const rx = offX+x*T, ry = offY+y*T;

            // Letter path
            const lcx = rx+T/2, lcy = ry+T/2-2;
            const letterBaseline = lcy + 30*0.38;
            svg += `  ${glyphToPathStr(exportFont, letter, lcx, letterBaseline, 30, LASER_ENGRAVE)}\n`;

            // Score number path
            const ncx = rx+T-10, ncy = ry+T-10;
            const numBaseline = ncy + 9*0.38;
            svg += `  ${glyphToPathStr(exportFont, score.toString(), ncx, numBaseline, 9, LASER_ENGRAVE)}\n`;
        }
        svg += `</g>\n`;

        /* LEGEND — kept as text (informational, not laser-cut) */
        const legendY = H + LEGEND_H * 0.62;
        svg += `<g id="layer-legend" font-family="Arial, Helvetica, sans-serif" font-size="10">\n`;
        let lx = 10;
        svg += `  <text x="${lx}" y="${legendY}" fill="${LASER_CUT}" font-weight="bold">Red</text>`;
        lx += 24;
        svg += `<text x="${lx}" y="${legendY}" fill="#555">=CUT</text>`;
        lx += 40;
        svg += `<text x="${lx}" y="${legendY}" fill="#999"> \u00b7 </text>`;
        lx += 16;
        svg += `<text x="${lx}" y="${legendY}" fill="${LASER_ENGRAVE}" font-weight="bold">Black</text>`;
        lx += 34;
        svg += `<text x="${lx}" y="${legendY}" fill="#555">=Engrave</text>`;
        lx += 56;
        svg += `<text x="${lx}" y="${legendY}" fill="#999"> \u00b7 </text>`;
        lx += 16;
        svg += `<text x="${lx}" y="${legendY}" fill="${LASER_SCORE}" font-weight="bold">Blue</text>`;
        lx += 28;
        svg += `<text x="${lx}" y="${legendY}" fill="#555">=Score</text>`;
        svg += `\n</g>\n`;
        svg += `</svg>`;

        /* Physical size — width-based */
        const aspect = W / totalH;
        let physWidthIn;
        if (exportUnit === 'mm') {
            physWidthIn = exportWidth / IN_TO_MM;
        } else {
            physWidthIn = exportWidth;
        }
        const physHeightIn = physWidthIn / aspect;

        svg = svg.replace(/<svg([^>]*)>/, (match, attrs) => {
            return `<svg${attrs} width="${physWidthIn.toFixed(4)}in" height="${physHeightIn.toFixed(4)}in">`;
        });

        const blob = new Blob(
            ['<?xml version="1.0" encoding="UTF-8"?>\n' + svg],
            { type: 'image/svg+xml' }
        );
        const url = URL.createObjectURL(blob);
        const a = Object.assign(document.createElement('a'), {
            href: url,
            download: 'scrabble_ornament.svg'
        });
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    });

    /* ── text → SVG path helper (uses opentype.js) ──────── */

    function glyphToPathStr(font, text, cx, baseline, fontSize, fill) {
        const advance = font.getAdvanceWidth(text, fontSize);
        const x = cx - advance / 2;
        const path = font.getPath(text, x, baseline, fontSize);
        const d = path.toPathData(2);
        return `<path d="${d}" fill="${fill}"/>`;
    }

    /* ── init ──────────────────────────────────────────────── */
    (function init() {
        grid = buildGrid(["MARIA","PABLO","OWEN"], false);
        syncSizeInput();
        renderBoard();

        // Load font for SVG path export
        if (typeof opentype !== 'undefined') {
            opentype.load(
                'https://cdn.jsdelivr.net/npm/@fontsource/inter/files/inter-latin-700-normal.woff',
                function(err, font) { if (!err && font) exportFont = font; }
            );
        }
    })();
})();